export default "__VITE_ASSET__D8I33V_e__"